import SectionHeroSearch from './SectionHeroSearch';
export default SectionHeroSearch;
